import { ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons'
import { useTranslation } from 'react-i18next'
import * as Select from '@radix-ui/react-select'

import { useSignupStore } from '@/reducers'

export const IntendedPurposeSelector = () => {
  const { t } = useTranslation()
  const { purpose } = useSignupStore()
  const setPurpose = useSignupStore.use.setPurpose()

  const options = [
    {
      value: 'Virtual currency exchange to purchase goods or services',
      label: t('intendedPurposeSelector.options.virtualCurrencyExchange'),
    },
    {
      value: 'Virtual currency exchange for family support',
      label: t('intendedPurposeSelector.options.familySupport'),
    },
    {
      value: 'Contributing to personal savings',
      label: t('intendedPurposeSelector.options.personalSavings'),
    },
    {
      value: 'General living expenses',
      label: t('intendedPurposeSelector.options.livingExpenses'),
    },
  ]

  return (
    <div data-testid="container-purpose-selector">
      <Select.Root
        required
        value={purpose}
        onValueChange={(value) => {
          setPurpose(value)
        }}
      >
        <Select.Trigger
          data-testid="select-purpose-trigger"
          className="text-pebble dark:text-snow py-2 h-full w-full inline-flex items-end leading-none gap-[5px] min-w-[150px] justify-between outline-none border-b-rock border-b-2"
        >
          <span style={{ textAlign: 'left' }}>
            <div
              data-testid="text-purpose-value"
              className={
                purpose ? 'text-black dark:text-white' : 'text-gray-400'
              }
            >
              <Select.Value
                placeholder={t('intendedPurposeSelector.placeholder')}
              />
            </div>
          </span>
          <Select.Icon className="text-gray-400">
            <ChevronDownIcon />
          </Select.Icon>
        </Select.Trigger>
        <Select.Portal>
          <Select.Content
            data-testid="container-purpose-dropdown"
            className="bg-white dark:bg-pebble border border-pebble dark:border-white overflow-hidden max-w-[90vw] md:max-w-80"
          >
            <Select.ScrollUpButton
              data-testid="btn-purpose-scroll-up"
              className="p-2.5"
            >
              <ChevronUpIcon />
            </Select.ScrollUpButton>
            <Select.Viewport>
              {options.map((option, index) => {
                return (
                  <Select.Item
                    key={option.value}
                    value={option.value}
                    style={{ textAlign: 'left' }}
                    className="hover:bg-rock min-w-[150px] justify-between p-2 cursor-pointer"
                    data-testid={`option-purpose-${index}`}
                  >
                    <Select.ItemText>{option.label}</Select.ItemText>
                  </Select.Item>
                )
              })}
            </Select.Viewport>
            <Select.ScrollDownButton
              data-testid="btn-purpose-scroll-down"
              className="p-2.5"
            >
              <ChevronDownIcon />
            </Select.ScrollDownButton>
          </Select.Content>
        </Select.Portal>
      </Select.Root>
    </div>
  )
}
